import { ReactNode } from 'react'

interface ButtonPrimaryProps {
  children: ReactNode
  size?: 'sm' | 'md' | 'lg'
  className?: string
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
}

export function ButtonPrimary({ children, size = 'md', className = '', onClick, type = 'button', disabled }: ButtonPrimaryProps) {
  const sizes = {
    sm: 'px-4 sm:px-5 py-2.5 text-xs sm:text-sm min-h-[44px]',
    md: 'px-5 sm:px-6 md:px-7 py-2.5 sm:py-3 text-sm',
    lg: 'px-6 sm:px-7 md:px-9 py-3 sm:py-3.5 md:py-4 text-sm sm:text-base',
  }
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`relative inline-flex items-center gap-2 font-display font-semibold rounded-pill whitespace-nowrap
        text-white overflow-hidden
        hover:opacity-90 hover:scale-[1.02] active:scale-[0.98]
        transition-all duration-150 cursor-pointer
        disabled:opacity-50 disabled:cursor-not-allowed
        ${sizes[size]} ${className}`}
      style={{ background: 'linear-gradient(135deg, #E040A0 0%, #FFB76C 100%)' }}
    >
      <span className="absolute inset-0 bg-black/20 rounded-pill" />
      <span className="relative">{children}</span>
    </button>
  )
}
